export class ParcelGoods {
  typeOfGoods: string
  limitDate: string
  tempMin: string
  tempMax: string
  description: string
  features?: string

  constructor(limitDate: string, tempMin: string, tempMax: string, description: string) {
    this.typeOfGoods = "FOOD"
    this.limitDate = limitDate
    this.tempMin = tempMin
    this.tempMax = tempMax
    this.description = description
  }
}
